import { render } from "./IconLinkDevice.vue?vue&type=template&id=7230699f"
import script from "./IconLinkDevice.vue?vue&type=script&lang=ts"
export * from "./IconLinkDevice.vue?vue&type=script&lang=ts"
script.render = render

export default script